var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.classes
    ? _c("div", { staticClass: "requirement-classes" }, [
        _c("p", [_c("strong", [_vm._v(_vm._s(_vm.text))])]),
        _vm._v(" "),
        _c("div", { staticClass: "requirement-classes-bar visible-xs" }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 383.72 33",
              },
            },
            [
              _c("g", { attrs: { id: "bar" } }, [
                _c("rect", {
                  staticClass: "cls-4",
                  attrs: {
                    id: "Rechteck_777",
                    y: "8.5",
                    width: "95.75",
                    height: "16",
                  },
                }),
                _c("rect", {
                  staticClass: "cls-2",
                  attrs: {
                    id: "Rechteck_780",
                    x: "192.95",
                    y: "8.5",
                    width: "95.02",
                    height: "16",
                  },
                }),
                _c("rect", {
                  staticClass: "cls-3",
                  attrs: {
                    id: "Rechteck_778",
                    x: "95.75",
                    y: "8.5",
                    width: "97.2",
                    height: "16",
                  },
                }),
                _c("rect", {
                  staticClass: "cls-1",
                  attrs: {
                    id: "Rechteck_779",
                    x: "287.97",
                    y: "8.5",
                    width: "95.75",
                    height: "16",
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "g",
                {
                  staticClass: "requirement-classes-marker",
                  class: { active: _vm.isActive(1) },
                },
                [
                  _c("g", [
                    _c("circle", {
                      staticClass: "cls-6",
                      attrs: { cx: "47.87", cy: "16.5", r: "16.5" },
                    }),
                    _c("g", { staticClass: "cls-7", attrs: { id: "_1" } }, [
                      _c("g", { staticClass: "cls-7" }, [
                        _c("path", {
                          staticClass: "cls-5",
                          attrs: {
                            d: "m46.92,11.65c-.61.44-1.18.82-1.7,1.14-.51.31-1.17.59-1.97.86v-2.56c.81-.29,1.47-.58,2-.89.53-.3,1.13-.72,1.78-1.27h2.61v14.41h-2.73v-11.68Z",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                {
                  staticClass: "requirement-classes-marker",
                  class: { active: _vm.isActive(2) },
                },
                [
                  _c("g", [
                    _c("circle", {
                      staticClass: "cls-6",
                      attrs: { cx: "144.35", cy: "16.5", r: "16.5" },
                    }),
                    _c("g", { staticClass: "cls-7", attrs: { id: "_2" } }, [
                      _c("g", { staticClass: "cls-7" }, [
                        _c("path", {
                          staticClass: "cls-5",
                          attrs: {
                            d: "m149.38,12.64c0,1.39-.66,2.78-1.99,4.17-1.08,1.13-2.9,2.58-5.44,4.35h7.8v2.17h-10.8v-2.56c2.61-1.96,4.52-3.58,5.73-4.86,1.2-1.28,1.8-2.32,1.8-3.14,0-.65-.18-1.15-.54-1.5s-.88-.52-1.55-.52c-.6,0-1.09.18-1.45.53-.37.36-.58.86-.64,1.5h-3.04c-.06-1.26.37-2.26,1.29-3.02.92-.75,2.18-1.13,3.76-1.13s2.87.35,3.74,1.05c.88.69,1.31,1.68,1.31,2.96Z",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                {
                  staticClass: "requirement-classes-marker",
                  class: { active: _vm.isActive(3) },
                },
                [
                  _c("g", [
                    _c("circle", {
                      staticClass: "cls-6",
                      attrs: { cx: "240.46", cy: "16.5", r: "16.5" },
                    }),
                    _c("g", { staticClass: "cls-7", attrs: { id: "_3" } }, [
                      _c("g", { staticClass: "cls-7" }, [
                        _c("path", {
                          staticClass: "cls-5",
                          attrs: {
                            d: "m242.95,12.8c0-.63-.2-1.13-.6-1.5-.4-.37-.95-.55-1.65-.55-.66,0-1.18.16-1.57.49-.39.33-.62.78-.67,1.36h-2.89c-.05-1.12.41-2.06,1.4-2.82.99-.76,2.23-1.14,3.74-1.14s2.7.37,3.68,1.12,1.47,1.68,1.47,2.8c0,1-.3,1.81-.9,2.42-.44.45-1,.74-1.66.85.63.16,1.15.39,1.57.67.88.61,1.32,1.59,1.32,2.93,0,1.26-.51,2.28-1.52,3.04-1.01.76-2.37,1.14-4.06,1.14-1.78,0-3.11-.33-3.99-1s-1.37-1.73-1.49-3.19h2.89c.03.67.28,1.19.73,1.56s1.07.55,1.86.55c.85,0,1.51-.2,1.98-.59s.71-.95.71-1.67c0-.76-.27-1.34-.81-1.72-.54-.38-1.37-.57-2.47-.57h-.69v-2.12h.03c1.09,0,1.97-.19,2.62-.56s.98-.86.98-1.48Z",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                {
                  staticClass: "requirement-classes-marker",
                  class: { active: _vm.isActive(4) },
                },
                [
                  _c("g", [
                    _c("circle", {
                      staticClass: "cls-6",
                      attrs: { cx: "335.85", cy: "16.5", r: "16.5" },
                    }),
                    _c("g", { staticClass: "cls-7", attrs: { id: "_4" } }, [
                      _c("g", { staticClass: "cls-7" }, [
                        _c("path", {
                          staticClass: "cls-5",
                          attrs: {
                            d: "m329,20.01v-2.53l6.05-8.6h3.48v8.96h2.53v2.17h-2.53v3.32h-2.68v-3.32h-6.85Zm6.85-2.17v-6.59l-4.26,6.23-.26.36h4.52Z",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "requirement-classes-bar hidden-xs" }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 529 33",
              },
            },
            [
              _c("g", { attrs: { id: "bar" } }, [
                _c("rect", {
                  staticClass: "cls-4",
                  attrs: {
                    id: "Rechteck_777",
                    y: "9.5",
                    width: "132",
                    height: "14",
                  },
                }),
                _c("rect", {
                  staticClass: "cls-2",
                  attrs: {
                    id: "Rechteck_780",
                    x: "266",
                    y: "9.5",
                    width: "131",
                    height: "14",
                  },
                }),
                _c("rect", {
                  staticClass: "cls-3",
                  attrs: {
                    id: "Rechteck_778",
                    x: "132",
                    y: "9.5",
                    width: "134",
                    height: "14",
                  },
                }),
                _c("rect", {
                  staticClass: "cls-1",
                  attrs: {
                    id: "Rechteck_779",
                    x: "397",
                    y: "9.5",
                    width: "132",
                    height: "14",
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "g",
                {
                  staticClass: "requirement-classes-marker",
                  class: { active: _vm.isActive(1) },
                },
                [
                  _c("g", [
                    _c("circle", {
                      staticClass: "cls-6 ",
                      attrs: { cx: "66", cy: "16.5", r: "16.5" },
                    }),
                    _c("g", { staticClass: "cls-7", attrs: { id: "_1" } }, [
                      _c("g", { staticClass: "cls-7" }, [
                        _c("path", {
                          staticClass: "cls-5",
                          attrs: {
                            d: "m65.04,11.65c-.61.44-1.18.82-1.7,1.14-.51.31-1.17.59-1.97.86v-2.56c.81-.29,1.47-.58,2-.89.53-.3,1.13-.72,1.78-1.27h2.61v14.41h-2.73v-11.68Z",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                {
                  staticClass: "requirement-classes-marker",
                  class: { active: _vm.isActive(2) },
                },
                [
                  _c("g", [
                    _c("circle", {
                      staticClass: "cls-6",
                      attrs: { cx: "199", cy: "16.5", r: "16.5" },
                    }),
                    _c("g", { staticClass: "cls-7", attrs: { id: "_2" } }, [
                      _c("g", { staticClass: "cls-7" }, [
                        _c("path", {
                          staticClass: "cls-5",
                          attrs: {
                            d: "m204.03,12.64c0,1.39-.66,2.78-1.99,4.17-1.08,1.13-2.9,2.58-5.44,4.35h7.8v2.17h-10.8v-2.56c2.61-1.96,4.52-3.58,5.73-4.86,1.2-1.28,1.8-2.32,1.8-3.14,0-.65-.18-1.15-.54-1.5s-.88-.52-1.55-.52c-.6,0-1.09.18-1.45.53-.37.36-.58.86-.64,1.5h-3.04c-.06-1.26.37-2.26,1.29-3.02.92-.75,2.18-1.13,3.76-1.13s2.87.35,3.74,1.05c.88.69,1.31,1.68,1.31,2.96Z",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                {
                  staticClass: "requirement-classes-marker",
                  class: { active: _vm.isActive(3) },
                },
                [
                  _c("g", [
                    _c("circle", {
                      staticClass: "cls-6",
                      attrs: { cx: "331.5", cy: "16.5", r: "16.5" },
                    }),
                    _c("g", { staticClass: "cls-7", attrs: { id: "_3" } }, [
                      _c("g", { staticClass: "cls-7" }, [
                        _c("path", {
                          staticClass: "cls-5",
                          attrs: {
                            d: "m333.99,12.8c0-.63-.2-1.13-.6-1.5-.4-.37-.95-.55-1.65-.55-.66,0-1.18.16-1.57.49-.39.33-.62.78-.67,1.36h-2.89c-.05-1.12.41-2.06,1.4-2.82.99-.76,2.23-1.14,3.74-1.14s2.7.37,3.68,1.12,1.47,1.68,1.47,2.8c0,1-.3,1.81-.9,2.42-.44.45-1,.74-1.66.85.63.16,1.15.39,1.57.67.88.61,1.32,1.59,1.32,2.93,0,1.26-.51,2.28-1.52,3.04-1.01.76-2.37,1.14-4.06,1.14-1.78,0-3.11-.33-3.99-1s-1.37-1.73-1.49-3.19h2.89c.03.67.28,1.19.73,1.56s1.07.55,1.86.55c.85,0,1.51-.2,1.98-.59s.71-.95.71-1.67c0-.76-.27-1.34-.81-1.72-.54-.38-1.37-.57-2.47-.57h-.69v-2.12h.03c1.09,0,1.97-.19,2.62-.56s.98-.86.98-1.48Z",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                {
                  staticClass: "requirement-classes-marker",
                  class: { active: _vm.isActive(4) },
                },
                [
                  _c("g", [
                    _c("circle", {
                      staticClass: "cls-6",
                      attrs: { cx: "463", cy: "16.5", r: "16.5" },
                    }),
                    _c("g", { staticClass: "cls-7", attrs: { id: "_4" } }, [
                      _c("g", { staticClass: "cls-7" }, [
                        _c("path", {
                          staticClass: "cls-5",
                          attrs: {
                            d: "m456.16,20.01v-2.53l6.05-8.6h3.48v8.96h2.53v2.17h-2.53v3.32h-2.68v-3.32h-6.85Zm6.85-2.17v-6.59l-4.26,6.23-.26.36h4.52Z",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(this.classDescriptors, function (c, key) {
              return _c(
                "div",
                {
                  staticClass: "col-xs-12 col-md-3 requirement-classes-label",
                  class: { active: _vm.isActive(key) },
                },
                [
                  _c("strong", [
                    _c("span", [_vm._v(_vm._s(key) + " ")]),
                    _vm._v(_vm._s(c)),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }